import { AboutComponent } from "./about.component";
import { Routes, RouterModule } from "@angular/router";

export const AboutRoutes: Routes = [
  {
    path: "about",
    component: AboutComponent
  }
];
